var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/Marketplace/MarketplaceUtils.ts
import { isEmpty, minBy, sumBy } from "lodash";
var calculateModularProductsPrice = (modularProducts) => modularProducts == null ? void 0 : modularProducts.reduce((acc, subProduct) => acc + subProduct.price * subProduct.amount, 0);
var calculateUpgradeOptionsPrice = (upgradeOptions) => sumBy(upgradeOptions, (option) => {
  var _a;
  return option.type === "byUnit" ? option.price * ((_a = option.amount) != null ? _a : 0) : option.price;
});
var getDefaultPriceTypeArray = (service) => {
  service.pricingTable = service.pricingTable;
  if (isEmpty(service.pricingTable))
    return [];
  switch (service.chosenPriceType) {
    case "byModular":
      return [];
    default:
      return service.pricingTable[getDefaultTypeToShow(service)];
  }
};
var priceTypeOrder = ["byPerson", "byGroup", "byPlatte", "byUnit", "byPackage"];
var getDefaultTypeToShow = (service) => {
  if (service.chosenPriceType) {
    return service.chosenPriceType;
  }
  const typeIndex = priceTypeOrder.findIndex(
    (type) => !isEmpty(service.pricingTable[type]) && service.pricingTable[type].some((row) => row.price)
  );
  return typeIndex >= 0 ? priceTypeOrder[typeIndex] : priceTypeOrder[0];
};
var getPriceByAmountWithPriceOptionArray = (amount, priceOptionArray, findPriceIfAmountIsOutOfRange = true) => {
  if (!(priceOptionArray == null ? void 0 : priceOptionArray.length)) {
    return 0;
  }
  if (!amount) {
    let lowestPrice = null;
    priceOptionArray.forEach((row) => {
      if (!lowestPrice || parseFloat(lowestPrice) > parseFloat(row.price)) {
        lowestPrice = row.price;
      }
    });
    return lowestPrice;
  }
  const cleanOptions = priceOptionArray.filter((row) => row.price);
  const index = cleanOptions.findIndex((row) => {
    return row.price && parseInt(row.min) <= parseInt(amount) && parseInt(row.max) >= parseInt(amount);
  });
  if (index >= 0) {
    return cleanOptions[index].price;
  }
  if (!findPriceIfAmountIsOutOfRange) {
    return NaN;
  }
  if (parseInt(amount) < parseInt(cleanOptions[0].min)) {
    return cleanOptions[0].price;
  } else if (parseInt(amount) > parseInt(cleanOptions[cleanOptions.length - 1].max)) {
    return cleanOptions[cleanOptions.length - 1].price;
  }
  return "---";
};
var getPriceByAmount = (amount, product, findPriceIfAmountIsOutOfRange = true) => {
  var _a;
  const priceOptionArray = (_a = getDefaultPriceTypeArray(product != null ? product : {})) != null ? _a : [];
  return getPriceByAmountWithPriceOptionArray(amount, priceOptionArray, findPriceIfAmountIsOutOfRange);
};

// src/Order/consts.ts
var OrderStatus = {
  accepted: "accepted",
  pending: "pending",
  cancelled: "cancelled",
  declined: "declined",
  expired: "expired",
  cancelPending: "cancel-pending",
  billed: "billed",
  paid: "paid",
  pendingDelivery: "pendingDelivery",
  deliveryExpired: "deliveryExpired",
  delivered: "delivered",
  deliveryError: "deliveryError",
  creditCardError: "creditCardError",
  creditCardNotPaid: "creditCardNotPaid",
  firstOrderForUser: "firstOrderForUser",
  notFirstOrderForUser: "notFirstOrderForUser",
  pendingManagerConfirm: "PendingManagerConfirm",
  canceledByManager: "CanceledByManager",
  PickedUpByProvider: "PickedUpByProvider",
  PickedUpByDeliveryProvider: "PickedUpByDeliveryProvider"
};
var OrderStatusToHebrew = {
  [OrderStatus.accepted]: "\u05D4\u05D6\u05DE\u05E0\u05D4 \u05D0\u05D5\u05E9\u05E8\u05D4",
  [OrderStatus.pending]: "\u05DE\u05DE\u05EA\u05D9\u05DF \u05DC\u05D0\u05D9\u05E9\u05D5\u05E8",
  [OrderStatus.pendingDelivery]: "\u05DE\u05D5\u05E2\u05D3 \u05D4\u05D0\u05E1\u05E4\u05E7\u05D4 \u05D7\u05DC\u05E3, \u05DE\u05DE\u05EA\u05D9\u05DF \u05DC\u05D7\u05D9\u05D5\u05D5\u05D9",
  [OrderStatus.deliveryExpired]: "\u05DE\u05D5\u05E2\u05D3 \u05D4\u05D0\u05E1\u05E4\u05E7\u05D4 \u05D7\u05DC\u05E3, \u05DE\u05DE\u05EA\u05D9\u05DF \u05DC\u05D7\u05D9\u05D5\u05D5\u05D9",
  [OrderStatus.cancelled]: "\u05D4\u05D6\u05DE\u05E0\u05D4 \u05D1\u05D5\u05D8\u05DC\u05D4",
  [OrderStatus.declined]: "\u05D4\u05D6\u05DE\u05E0\u05D4 \u05E1\u05D5\u05E8\u05D1\u05D4",
  [OrderStatus.expired]: "\u05E4\u05D2 \u05EA\u05D5\u05E7\u05E3",
  [OrderStatus.deliveryError]: "\u05EA\u05E7\u05DC\u05D4 \u05D1\u05E9\u05D9\u05DC\u05D5\u05D7",
  [OrderStatus.cancelPending]: "\u05DE\u05DE\u05EA\u05D9\u05DF \u05DC\u05E1\u05D9\u05E8\u05D5\u05D1",
  [OrderStatus.paid]: "\u05E9\u05D5\u05DC\u05DD",
  [OrderStatus.delivered]: "\u05D4\u05D6\u05DE\u05E0\u05D4 \u05E1\u05D5\u05E4\u05E7\u05D4",
  [OrderStatus.creditCardError]: "\u05E9\u05D2\u05D9\u05D0\u05D4 \u05D1\u05E1\u05DC\u05D9\u05E7\u05D4",
  [OrderStatus.creditCardNotPaid]: "\u05D0\u05E9\u05E8\u05D0\u05D9 \u05DC\u05D0 \u05E0\u05E1\u05DC\u05E7",
  [OrderStatus.firstOrderForUser]: "\u05D4\u05D6\u05DE\u05E0\u05D4 \u05E8\u05D0\u05E9\u05D5\u05E0\u05D4 \u05DC\u05DE\u05E9\u05EA\u05DE\u05E9",
  [OrderStatus.notFirstOrderForUser]: "\u05DC\u05D0 \u05D4\u05D6\u05DE\u05E0\u05D4 \u05E8\u05D0\u05E9\u05D5\u05E0\u05D4 \u05DC\u05DE\u05E9\u05EA\u05DE\u05E9",
  [OrderStatus.pendingManagerConfirm]: "\u05DE\u05DE\u05EA\u05D9\u05DF \u05DC\u05D0\u05D9\u05E9\u05D5\u05E8 \u05DE\u05E0\u05D4\u05DC",
  [OrderStatus.canceledByManager]: "\u05E1\u05D5\u05E8\u05D1 \u05E2\u05DC \u05D9\u05D3\u05D9 \u05DE\u05E0\u05D4\u05DC",
  [OrderStatus.PickedUpByDeliveryProvider]: "\u05D1\u05E9\u05D9\u05DC\u05D5\u05D7 \u05DC\u05D9\u05E2\u05D3"
};

// src/utils/DateUtils.ts
import moment from "moment/moment";

// src/utils/StringBuilder.ts
var StringBuilder = class {
  constructor(initValue = null, separator = " ") {
    this.strings = [];
    this.strings = initValue ? [initValue] : [];
    this.separator = separator;
  }
  append(...value) {
    this.strings.push(...value);
    return this;
  }
  toString() {
    var _a;
    return this.strings.filter(Boolean).join((_a = this.separator) != null ? _a : " ").replace(/ {2,}/g, " ");
  }
};

// src/utils/DateUtils.ts
var dateTimeRange = (dtStart = null, until) => {
  if (!dtStart) {
    return null;
  }
  const dtStartHourFormat = moment(dtStart).format("HH:mm");
  const dtStartDateFormat = moment(dtStart).format("DD/MM/YYYY");
  const untilHourFormat = until ? moment(until).format("HH:mm") : null;
  const untilDateFormat = until ? moment(until).format("DD/MM/YYYY") : null;
  const isSameDtStartAndUntilDate = dtStartDateFormat === untilDateFormat;
  const isSameDtStartAndUntilHour = dtStartHourFormat === untilHourFormat;
  const duration = until ? moment(until).diff(moment(dtStart)) : null;
  const durationFormat = duration ? formatHebrewTimeString(moment.duration(Math.abs(duration))) : null;
  return __spreadValues(__spreadValues(__spreadValues({}, duration ? { duration, durationFormat } : {}), isSameDtStartAndUntilDate ? { dtStartDateFormat } : { dtStartDateFormat, untilDateFormat }), isSameDtStartAndUntilHour ? { dtStartHourFormat } : { dtStartHourFormat, untilHourFormat });
};
var formatHebrewTimeString = (time) => {
  if (!time || isNaN(time.asMinutes())) {
    return null;
  }
  const days = Math.floor(time.asDays());
  const hours = Math.floor(time.asHours()) - days * 24;
  const minutes = Math.floor(time.asMinutes()) - (days * 24 * 60 + hours * 60);
  const stringBuilder = new StringBuilder();
  if (days > 0) {
    stringBuilder.append(`${days} \u05D9\u05DE\u05D9\u05DD`);
  }
  if (hours > 0) {
    stringBuilder.append(`${hours} \u05E9\u05E2\u05D5\u05EA`);
  }
  if (minutes > 0) {
    stringBuilder.append(hours > 0 || days > 0 ? "\u05D5-" : "").append(`${minutes} \u05D3\u05E7\u05D5\u05EA`);
  }
  if (stringBuilder.toString().trim() === "") {
    return "0 \u05D3\u05E7\u05D5\u05EA";
  }
  return stringBuilder.toString();
};
var dateTimeRangeFormat = (dtstart, until = null) => {
  const dtStartHourFormat = moment(dtstart).format("HH:mm");
  const dtStartDateFormat = moment(dtstart).format("DD/MM/YYYY");
  const untilHourFormat = until ? moment(until).format("HH:mm") : null;
  const untilDateFormat = until ? moment(until).format("DD/MM/YYYY") : null;
  const isSameDtStartAndUntilDate = untilDateFormat === dtStartDateFormat;
  return `${dtStartDateFormat}, ${dtStartHourFormat} ${until ? `- ${isSameDtStartAndUntilDate ? "" : `${untilDateFormat}, `}${untilHourFormat}` : ""}`;
};
var DateUtils_default = { dateTimeRange, formatHebrewTimeString, dateTimeRangeFormat };

// src/Order/utils.ts
import moment2 from "moment/moment";

// src/consts.ts
var themeNames = {
  tenBis: "tenbis",
  wellB: "wellb"
};
var AllowedSystemIdBudgetLoadPaymentType = {
  [themeNames.tenBis]: ["tenBisCard" /* TenBisCard */, "card" /* Card */],
  [themeNames.wellB]: ["card" /* Card */, "bankTransfer" /* BankTransfer */]
};
var MaxShippingProvidersDeliveryPriceWithVAT = 118;
var VAT = 1.18;

// src/utils/calculationUtils.ts
import { isNumber } from "lodash";
var isValidVat = (vat) => isNumber(vat) && !isNaN(vat) && vat > 0;
var reduceVAT = (price, vat, withFixed = true) => {
  if (!isValidVat(vat)) {
    console.error("Invalid VAT: must be a positive number.");
    return NaN;
  }
  if (!isNumber(price) || isNaN(price)) {
    console.error(`Invalid price: ${price} must be a number.`);
    return NaN;
  }
  const priceWithoutVat = price / vat;
  if (withFixed) {
    return parseFloat(priceWithoutVat.toFixed(0));
  }
  return priceWithoutVat;
};
var calculateSubProductPriceWithoutCommission = (price, commission, vat) => {
  if (!isValidVat(vat)) {
    console.error("Invalid VAT: must be a positive number.");
    return NaN;
  }
  const priceWithoutCommission = price - price * (commission * vat) / 100;
  return parseFloat(priceWithoutCommission.toLocaleString("en-GB", {
    maximumFractionDigits: 1,
    useGrouping: false
  }));
};
var calculateSubProductCommission = (price, priceWithoutCommission, vat) => {
  if (!isValidVat(vat)) {
    console.error("Invalid VAT: must be a positive number.");
    return NaN;
  }
  return parseFloat(((price - priceWithoutCommission) / (price * vat) * 100).toLocaleString("en-GB", {
    maximumFractionDigits: 1,
    useGrouping: false
  }));
};
var calculateSubProductPrice = (priceWithoutCommission, commission, vat) => {
  if (!isValidVat(vat)) {
    console.error("Invalid VAT: must be a positive number.");
    return NaN;
  }
  return parseFloat((priceWithoutCommission / (1 - commission / 100 * vat)).toLocaleString("en-GB", {
    maximumFractionDigits: 1,
    useGrouping: false
  }));
};
var getDeliveryPriceForInvoice = (order, deliveryCommission = "8", isExemptDealerType = true, maxShippingProvidersDeliveryPrice) => {
  var _a;
  const priceLimitWithVAT = (order == null ? void 0 : order.chosenActivityLocation) === "homeDelivery" /* HomeDelivery */ && (order == null ? void 0 : order.homeDeliveryUploadMethod) === "excel" /* excel */ ? Number.MAX_SAFE_INTEGER : maxShippingProvidersDeliveryPrice != null ? maxShippingProvidersDeliveryPrice : MaxShippingProvidersDeliveryPriceWithVAT;
  if (isOrderHasShippingProvider(order)) {
    const parseCommission = parseFloat(deliveryCommission) / 100;
    const calculateDeliveryCommissionPrice = Math.ceil(
      parseFloat(String(order.offeredPrice)) * (parseCommission * (isExemptDealerType ? 1 : (_a = order.vat) != null ? _a : VAT))
    );
    if (calculateDeliveryCommissionPrice > priceLimitWithVAT) {
      return priceLimitWithVAT * -1;
    }
    return calculateDeliveryCommissionPrice * -1;
  }
  if (isExemptDealerType) {
    return reduceVAT(order.deliveryPrice, order.vat);
  }
  return order.deliveryPrice;
};
var getInvoicePrice = (offeredPrice, commission = "20", includeVAT = true, vat = VAT) => {
  const calculateOfferedPrice2 = includeVAT ? offeredPrice : reduceVAT(offeredPrice, vat);
  return Math.ceil(
    calculateOfferedPrice2 - offeredPrice * (parseFloat(commission) / 100) * (includeVAT ? vat != null ? vat : VAT : 1)
  );
};
var getOrderDiscountPrice = (order, includeVAT = true) => {
  var _a, _b;
  const totalDiscount = parseFloat((_a = order.couponDiscountAmount) != null ? _a : 0) + parseFloat((_b = order.companyDiscountAmount) != null ? _b : 0);
  return includeVAT ? totalDiscount * -1 : reduceVAT(totalDiscount, order.vat) * -1;
};
var calculationUtils_default = {
  reduceVAT,
  calculateSubProductPriceWithoutCommission,
  calculateSubProductCommission,
  calculateSubProductPrice,
  getDeliveryPriceForInvoice,
  getInvoicePrice,
  getOrderDiscountPrice
};

// src/Order/utils.ts
var calculateOfferedPrice = (order, product, chosenPriceType) => {
  const toUpdate = { offeredPrice: void 0 };
  if (chosenPriceType === "byModular") {
    return calculateModularProductsPrice(order.modularProducts) + calculateUpgradeOptionsPrice(order.upgradeOptions.options);
  } else {
    const currentPriceByAmount = getPriceByAmount(order.amount || 0, product);
    const newOfferedPrice = currentPriceByAmount ? (parseFloat(currentPriceByAmount.toString().replace(",", "")) * (getDefaultTypeToShow(product) === "byGroup" ? 1 : parseFloat(order.amount || "0"))).toFixed(0) : null;
    return newOfferedPrice + calculateUpgradeOptionsPrice(order.upgradeOptions.options);
  }
};
var isUserNeedManagerConfirm = (company, creatingOrderUser) => (company == null ? void 0 : company.needManagerConfirm) && !(creatingOrderUser == null ? void 0 : creatingOrderUser.isCompanyMaster);
var isOrderPendingForManagerConfirm = (order) => {
  var _a;
  return (order == null ? void 0 : order.status) === OrderStatus.pending && order.needManagerConfirm && (order == null ? void 0 : order.status) === OrderStatus.pending && ((_a = order == null ? void 0 : order.eventStatusMap) != null ? _a : []).some(({ id }) => id === OrderStatus.pendingManagerConfirm);
};
var isOrderReviewedByManager = (order, isOrderNeedManagerConfirm) => order.needManagerConfirm && !isOrderPendingForManagerConfirm(order);
var isOrderApprovedByManager = (order, isOrderNeedManagerConfirm) => isOrderReviewedByManager(order, isOrderNeedManagerConfirm) && !(order == null ? void 0 : order.cancelReason);
function getSupplyDetails(order) {
  const { dtStartDateFormat, untilDateFormat, dtStartHourFormat, untilHourFormat } = dateTimeRange(
    order.dtstart,
    order == null ? void 0 : order.until
  );
  const supplyDate = `${dtStartDateFormat} ${untilDateFormat ? ` - ${untilDateFormat}` : ""}`;
  const supplyHours = `${dtStartHourFormat} ${untilHourFormat ? ` - ${untilHourFormat}` : ""}`;
  return { supplyDate, supplyHours };
}
var isOrderHasShippingProvider = (order) => {
  var _a;
  return Array.isArray(order == null ? void 0 : order.shippingProviders) && !((_a = order == null ? void 0 : order.shippingProviders) == null ? void 0 : _a.includes("regular" /* regular */));
};
function calculateDeliveryTime(order, minutesToSubtract = 30, referenceHour = 6, referenceMinute = 0) {
  if (!isOrderHasShippingProvider(order)) {
    return null;
  }
  const dtStartMoment = moment2(order == null ? void 0 : order.dtstart);
  const adjustedTime = dtStartMoment.clone().subtract(minutesToSubtract, "minutes");
  const referenceTime = dtStartMoment.clone().startOf("day").add(referenceHour, "hours").add(referenceMinute, "minutes");
  if (adjustedTime.isBefore(referenceTime)) {
    return referenceTime;
  } else {
    return adjustedTime;
  }
}
var getInvoicePriceByProviderId = (price, commission, provider, forceVAT = false, vat = VAT) => {
  const isExemptDealerType = (provider == null ? void 0 : provider.dealerType) === "exempt" /* Extempt */;
  if (forceVAT) {
    return getInvoicePrice(price, commission, !isExemptDealerType, vat);
  }
  return getInvoicePrice(price, commission, true, vat);
};
var getOrderPrice = (order, includeVAT = true) => {
  var _a, _b, _c;
  const calculatePrice = order.offeredPrice + getOrderDiscountPrice2(order, includeVAT) + ((_a = order.deliveryPrice) != null ? _a : 0) + ((_b = order.tip) != null ? _b : 0);
  return includeVAT ? calculatePrice : reduceVAT(calculatePrice, (_c = order.vat) != null ? _c : VAT);
};
var getOrderDiscountPrice2 = (order, includeVAT = true) => {
  var _a, _b, _c;
  const totalDiscount = parseFloat((_a = order.couponDiscountAmount) != null ? _a : 0) + parseFloat((_b = order.companyDiscountAmount) != null ? _b : 0);
  return includeVAT ? totalDiscount * -1 : reduceVAT(totalDiscount, (_c = order.vat) != null ? _c : VAT) * -1;
};
var utils_default = {
  calculateOfferedPrice,
  isUserNeedManagerConfirm,
  isOrderPendingForManagerConfirm,
  isOrderReviewedByManager,
  isOrderApprovedByManager,
  getSupplyDetails,
  isOrderHasShippingProvider,
  calculateDeliveryTime,
  getInvoicePriceByProviderId,
  getOrderDiscountPrice: getOrderDiscountPrice2,
  getOrderPrice
};

// src/utils/phoneNumberUtils.ts
var isValidPhoneMobileNumber = (phoneNumber) => {
  const regexPattern = /^05\d{8}$/;
  return phoneNumber && regexPattern.test(phoneNumber);
};
var sanitizePhone = (phone) => {
  const allowedCharacters = "0123456789";
  const pattern = new RegExp(`[^${allowedCharacters}]`, "g");
  return phone.toLowerCase().trim().replace(pattern, "");
};

// src/Product/consts.ts
var ProductKosherType = /* @__PURE__ */ ((ProductKosherType2) => {
  ProductKosherType2["NOT_NEEDED"] = "notneeded";
  ProductKosherType2["REGULAR"] = "regular";
  ProductKosherType2["MEHADRIN"] = "mehadrin";
  ProductKosherType2["BEDATZ"] = "bedatz";
  ProductKosherType2["TZOHAR"] = "tzohar";
  return ProductKosherType2;
})(ProductKosherType || {});
var ProductKosherTypesPriority = {
  ["mehadrin" /* MEHADRIN */]: 2,
  ["bedatz" /* BEDATZ */]: 1,
  ["regular" /* REGULAR */]: 0
};
var ProductKosherTypesToHebrew = {
  ["regular" /* REGULAR */]: "\u05DB\u05E9\u05E8\u05D5\u05EA \u05E8\u05D2\u05D9\u05DC\u05D4",
  ["tzohar" /* TZOHAR */]: "\u05DB\u05E9\u05E8\u05D5\u05EA \u05E6\u05D5\u05D4\u05E8",
  ["mehadrin" /* MEHADRIN */]: "\u05DB\u05E9\u05E8\u05D5\u05EA \u05DE\u05D4\u05D3\u05E8\u05D9\u05DF",
  ["bedatz" /* BEDATZ */]: "\u05DB\u05E9\u05E8\u05D5\u05EA \u05D1\u05D3\u05F4\u05E6",
  ["notneeded" /* NOT_NEEDED */]: "\u05D0\u05D9\u05DF \u05E6\u05D5\u05E8\u05DA \u05D1\u05DB\u05E9\u05E8\u05D5\u05EA \u05DC\u05E4\u05E2\u05D9\u05DC\u05D5\u05EA \u05D6\u05D5"
};
var ProviderActivityPossibleLocations = {
  ["online" /* Online */.valueOf()]: "\u05D6\u05DE\u05D9\u05DF \u05D0\u05D5\u05E0\u05DC\u05D9\u05D9\u05DF",
  ["office" /* Office */.valueOf()]: "\u05E9\u05D9\u05DC\u05D5\u05D7 \u05DC\u05DB\u05EA\u05D5\u05D1\u05EA \u05D4\u05E8\u05E9\u05D5\u05DE\u05D4",
  ["onsite" /* Onsite */.valueOf()]: "\u05D1\u05D1\u05D9\u05EA \u05D4\u05E2\u05E1\u05E7",
  ["homeDelivery" /* HomeDelivery */.valueOf()]: "\u05DE\u05E9\u05DC\u05D5\u05D7 \u05DC\u05D1\u05D9\u05EA \u05DE\u05E7\u05D1\u05DC \u05D4\u05DE\u05D0\u05E8\u05D6",
  ["manualLocation" /* ManualLocation */.valueOf()]: "\u05DB\u05EA\u05D5\u05D1\u05EA \u05D7\u05D9\u05E6\u05D5\u05E0\u05D9\u05EA"
};

// src/Product/ProductUtils.ts
import { difference, isNumber as isNumber2 } from "lodash";
var isProductActive = (product, provider, companyId) => {
  var _a;
  return (provider == null ? void 0 : provider.approved) && ((product == null ? void 0 : product.isActive) || ((_a = product == null ? void 0 : product.allowedCompanies) == null ? void 0 : _a.includes(companyId)));
};
var isProductValid = (productDetails) => {
  var _a, _b, _c, _d, _e, _f, _g;
  if (!((_a = productDetails == null ? void 0 : productDetails.services) == null ? void 0 : _a.length)) {
    return { error: "\u05D0\u05E0\u05D0 \u05D1\u05D7\u05E8 \u05E7\u05D8\u05D2\u05D5\u05E8\u05D9\u05D4" };
  }
  if (((_b = productDetails == null ? void 0 : productDetails.services) == null ? void 0 : _b.length) > 1) {
    return { error: "\u05DE\u05D5\u05E6\u05E8 \u05D9\u05DB\u05D5\u05DC \u05DC\u05D4\u05DB\u05D9\u05DC \u05E8\u05E7 \u05E7\u05D8\u05D2\u05D5\u05E8\u05D9\u05D4 \u05D0\u05D7\u05EA \u05D1\u05DC\u05D1\u05D3" };
  }
  if (!productDetails.chosenPriceType) {
    return { error: "\u05D0\u05E0\u05D0 \u05D1\u05D7\u05E8 \u05E1\u05D5\u05D2 \u05EA\u05DE\u05D7\u05D5\u05E8 \u05DC\u05E4\u05E2\u05D9\u05DC\u05D5\u05EA" };
  }
  if (((_c = productDetails.location) == null ? void 0 : _c.includes("onsite" /* Onsite */)) && !((_d = productDetails.address) == null ? void 0 : _d.length)) {
    return { error: `\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05D0\u05EA \u05DE\u05D9\u05E7\u05D5\u05DD \u05D4\u05E4\u05E2\u05D9\u05DC\u05D5\u05EA: \u05F4${ProviderActivityPossibleLocations["onsite" /* Onsite */.valueOf()]}\u05F4 \u05DC\u05DC\u05D0 \u05D4\u05D5\u05E1\u05E4\u05EA \u05DB\u05EA\u05D5\u05D1\u05D5\u05EA \u05E9\u05DC \u05D1\u05E2\u05DC \u05D4\u05E2\u05E1\u05E7` };
  }
  if (((_e = productDetails == null ? void 0 : productDetails.shippingProviders) == null ? void 0 : _e.length) !== 1) {
    return { error: "\u05D9\u05E9 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05D7\u05D1\u05E8\u05EA \u05E9\u05D9\u05DC\u05D5\u05D7 \u05D0\u05D7\u05EA \u05D1\u05DC\u05D1\u05D3" };
  }
  if (!((_f = productDetails == null ? void 0 : productDetails.shippingProviders) == null ? void 0 : _f.includes("regular" /* regular */))) {
    if (!isNumber2(productDetails == null ? void 0 : productDetails.deliveryCommission)) {
      return { error: "\u05D9\u05E9 \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05E2\u05DE\u05DC\u05EA \u05E9\u05D9\u05DC\u05D5\u05D7" };
    }
    if (productDetails == null ? void 0 : productDetails.address.some((address) => !address.placeId)) {
      return { error: "\u05D0\u05D7\u05EA \u05D4\u05DB\u05EA\u05D5\u05D1\u05D5\u05EA \u05E9\u05DC \u05D4\u05E1\u05E4\u05E7 \u05DC\u05D0 \u05DE\u05D6\u05D5\u05D4\u05D5\u05EA \u05E2\u05DD \u05D2\u05D5\u05D2\u05DC" };
    }
    if (!productDetails.address.length) {
      return { error: "\u05D1\u05DE\u05D5\u05E6\u05E8\u05D9\u05DD \u05E2\u05DD \u05E9\u05D9\u05DC\u05D5\u05D7 \u05D5\u05D5\u05DC\u05D1\u05D9 \u05D7\u05D5\u05D1\u05D4 \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05E1\u05E0\u05D9\u05E3 \u05D0\u05D7\u05D3 \u05DC\u05E4\u05D7\u05D5\u05EA \u05DC\u05E1\u05E4\u05E7 \u05D1\u05DC\u05D1\u05D3" };
    }
    const isProductHasAllowedEventLocations = difference(productDetails == null ? void 0 : productDetails.location, [
      "manualLocation" /* ManualLocation */,
      "homeDelivery" /* HomeDelivery */
    ]);
    if (isProductHasAllowedEventLocations == null ? void 0 : isProductHasAllowedEventLocations.length) {
      return { error: "\u05D1\u05DE\u05D5\u05E6\u05E8\u05D9\u05DD \u05E2\u05DD \u05E9\u05D9\u05DC\u05D5\u05D7 \u05D5\u05D5\u05DC\u05D1\u05D9 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05DB\u05E8\u05D2\u05E2 \u05E8\u05E7 \u05DB\u05EA\u05D5\u05D1\u05EA \u05D7\u05D9\u05E6\u05D5\u05E0\u05D9\u05EA  \u05D0\u05D5 \u05DE\u05E9\u05DC\u05D5\u05D7 \u05DC\u05D1\u05D9\u05EA \u05DE\u05E7\u05D1\u05DC \u05D4\u05DE\u05D0\u05E8\u05D6 \u05D1\u05DC\u05D1\u05D3" };
    }
  }
  if (!((_g = productDetails == null ? void 0 : productDetails.location) == null ? void 0 : _g.length)) {
    return { error: "\u05D7\u05D5\u05D1\u05D4 \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05DE\u05D9\u05E7\u05D5\u05DD \u05E4\u05E2\u05D9\u05DC\u05D5\u05EA \u05DC\u05DE\u05D5\u05E6\u05E8" };
  }
};

// src/utils/EmailUtils.ts
var isValidEmailRegex = (email) => {
  const validEmailRegex = /^(?=.{1,256})(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/;
  return validEmailRegex.test(email);
};

// src/Product/types.ts
var FoodRequestsIds = {
  veganFriendly: "veganFriendly",
  vegetarianFriendly: "vegetarianFriendly",
  glutenFree: "glutenFree",
  lactoseFree: "lactoseFree",
  furOption: "furOption"
};

// src/utils/ExcelUtils.ts
import { Workbook } from "exceljs";
var EXCEL_MAX_ROWS = 1048576;
var exportToExcel = ({ sheetsConfig }) => {
  const workbook = createWorkbook();
  sheetsConfig.forEach(({ title, data, columnsConfig, rowMapper, colorRowMapper }) => {
    const sheet = createWorksheet(workbook, title);
    addColumns(sheet, columnsConfig);
    addRows(sheet, data, rowMapper);
    if (colorRowMapper) {
      applyDynamicRowFormatting(sheet, colorRowMapper);
    }
  });
  return { workbook };
};
var addRows = (sheet, data, rowMapper) => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid data type");
  }
  const rows = rowMapper ? data.map(rowMapper) : data;
  sheet.addRows(rows);
};
var addColumns = (sheet, columnsConfig) => {
  sheet.columns = columnsConfig.columns;
  if (columnsConfig == null ? void 0 : columnsConfig.dropdownValidation) {
    columnsConfig.dropdownValidation.forEach(({ keys, options }) => {
      applyDropdownCellValidation(sheet, keys, options);
    });
  }
};
var createWorkbook = () => {
  const workbook = new Workbook();
  workbook.creator = "WellB";
  return workbook;
};
var createWorksheet = (workbook, title) => {
  const sheet = workbook.addWorksheet(title);
  sheet.views = [{ rightToLeft: true }];
  return sheet;
};
var extractDataFromExcel = (sheet, headerMapping, transformRow) => {
  const results = [];
  const headers = {};
  sheet.getRow(1).eachCell((cell, colNumber) => {
    const key = headerMapping[cell.value];
    if (key)
      headers[colNumber] = key;
  });
  sheet.eachRow((row, rowIndex) => {
    if (rowIndex === 1)
      return;
    const rowData = {};
    row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      const key = headers[colNumber] || `Column${colNumber}`;
      if (cell.value) {
        rowData[key] = cell.value;
      }
    });
    rowData.excelRowNumber = rowIndex;
    const data = transformRow ? transformRow(rowData, rowIndex) : rowData;
    results.push(data);
  });
  return results;
};
var applyDropdownCellValidation = (sheet, dropdownColumns, options = [], validationError = null, validationErrorTitle = null, initCellIndex = 2, endCellIndex = EXCEL_MAX_ROWS) => {
  dropdownColumns.forEach((key) => {
    const column = sheet.getColumn(key);
    if (!column) {
      return;
    }
    const range = `${column.letter}${initCellIndex}:${column.letter}${endCellIndex}`;
    const optionFormat = options.join(",");
    sheet.dataValidations.add(range, {
      type: "list",
      allowBlank: true,
      formulae: [`"${optionFormat}"`],
      // Dropdown options
      showErrorMessage: true,
      error: validationError != null ? validationError : new StringBuilder("\u05D1\u05D7\u05D9\u05E8\u05D4 \u05E9\u05D2\u05D5\u05D9\u05D4, \u05D0\u05E0\u05D0 \u05D1\u05D7\u05E8 \u05D0\u05EA \u05D0\u05D7\u05EA \u05D4\u05D0\u05D5\u05E4\u05E6\u05D9\u05D5\u05EA").append(optionFormat).toString(),
      errorTitle: validationErrorTitle != null ? validationErrorTitle : "\u05E9\u05D2\u05D9\u05D0\u05EA \u05D5\u05D5\u05DC\u05D9\u05D3\u05E6\u05D9\u05D4"
    });
  });
};
var applyDynamicRowFormatting = (sheet, colorMapper) => {
  var _a;
  const columnMap = sheet.columns.map(({ key, header }) => ({
    key,
    value: header
  }));
  const columnObject = Object.fromEntries(
    columnMap.map(({ key, value }) => [value, key])
  );
  const excelData = extractDataFromExcel(sheet, columnObject);
  for (let rowIndex = 0; rowIndex < sheet.rowCount - 1; rowIndex++) {
    const excelRowIndex = rowIndex + 2;
    const rowData = excelData[rowIndex];
    const colors = colorMapper ? (_a = colorMapper(rowData)) != null ? _a : {} : {};
    for (const [targetColumn, color] of Object.entries(colors)) {
      const columnLetter = sheet.getColumn(targetColumn).letter;
      if (color) {
        sheet.addConditionalFormatting({
          ref: `${columnLetter}${excelRowIndex}`,
          rules: [
            {
              type: "expression",
              formulae: ["TRUE"],
              style: {
                fill: {
                  type: "pattern",
                  pattern: "solid",
                  bgColor: { argb: color }
                }
              }
            }
          ]
        });
      }
    }
  }
};

// src/Order/index.ts
var Order_default = { OrderStatus, OrderStatusToHebrew, utils: utils_default };

// src/Report/consts.ts
var ReportName = /* @__PURE__ */ ((ReportName2) => {
  ReportName2["TOTAL_SUB_ADMINS_COMPANY_BUDGET_USAGE"] = "TOTAL_SUB_ADMINS_COMPANY_BUDGET_USAGE";
  ReportName2["ADMIN_ORDER_EXCEL_CSM_SUPPLIES"] = "ADMIN_ORDER_EXCEL_CSM_SUPPLIES";
  ReportName2["ADMIN_WELL_B_SHIPPING_SUPPLY_REPORT"] = "ADMIN_WELL_B_SHIPPING_SUPPLY_REPORT";
  ReportName2["ADMIN_ORDER_EXCEL_PROVIDER_SUPPLIES"] = "ADMIN_ORDER_EXCEL_PROVIDER_SUPPLIES";
  ReportName2["ADMIN_PROVIDERS_EXCEL"] = "ADMIN_PROVIDERS_EXCEL";
  return ReportName2;
})(ReportName || {});
var ReportsNameToText = {
  ["TOTAL_SUB_ADMINS_COMPANY_BUDGET_USAGE" /* TOTAL_SUB_ADMINS_COMPANY_BUDGET_USAGE */]: "\u05D3\u05D5\u05D7 \u05DE\u05D9\u05DE\u05D5\u05E9 \u05EA\u05E7\u05E6\u05D9\u05D1 \u05E9\u05DC \u05EA\u05EA\u05D9 \u05D0\u05D3\u05DE\u05D9\u05DF",
  ["ADMIN_WELL_B_SHIPPING_SUPPLY_REPORT" /* ADMIN_WELL_B_SHIPPING_SUPPLY_REPORT */]: "\u05D0\u05E7\u05E1\u05DC \u05E9\u05D9\u05DC\u05D5\u05D7 \u05E2\u05DD \u05D5\u05D5\u05DC\u05D1\u05D9",
  ["ADMIN_ORDER_EXCEL_CSM_SUPPLIES" /* ADMIN_ORDER_EXCEL_CSM_SUPPLIES */]: "\u05D3\u05D5\u05D7 \u05D0\u05E1\u05E4\u05E7\u05D5\u05EA \u05DE\u05E0\u05D4\u05DC\u05D5\u05EA \u05DC\u05E7\u05D5\u05D7",
  ["ADMIN_ORDER_EXCEL_PROVIDER_SUPPLIES" /* ADMIN_ORDER_EXCEL_PROVIDER_SUPPLIES */]: "\u05D3\u05D5\u05D7 \u05D0\u05E1\u05E4\u05E7\u05D5\u05EA \u05E9\u05D5\u05EA\u05E4\u05D9\u05DD",
  ["ADMIN_PROVIDERS_EXCEL" /* ADMIN_PROVIDERS_EXCEL */]: "\u05D3\u05D5\u05D7 \u05E9\u05D5\u05EA\u05E4\u05D9\u05DD"
};

// src/Report/index.ts
var Report_default = {
  ReportName,
  ReportsNameToText
};

// src/utils/StringUtils.ts
var removeEmojisFromString = (text) => text.replace(
  /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
  ""
);
var StringUtils_default = { removeEmojisFromString };

// src/utils/index.ts
var utils_default2 = { dateUtils: DateUtils_default, stringUtils: StringUtils_default, calculationUtils: calculationUtils_default };

// src/Product/index.ts
var Product_default = {
  ProductKosherType,
  ProductKosherTypesPriority,
  ProductKosherTypesToHebrew
};

// src/Provider/consts.ts
var DealerTypeToText = {
  ["licensed" /* Licensed */]: "Licensed dealer (\u05E2\u05D5\u05E1\u05E7 \u05DE\u05D5\u05E8\u05E9\u05D4)",
  ["exempt" /* Extempt */]: "Exempt dealer (\u05E2\u05D5\u05E1\u05E7 \u05E4\u05D8\u05D5\u05E8)",
  ["llc" /* Llc */]: "LLC (\u05D7\u05D1\u05E8\u05D4 \u05D1\u05E2\u05F4\u05DE)"
};

// src/Provider/index.ts
var Provider_default = {
  DealerTypeToText
};

// src/index.ts
var src_default = {
  calculateModularProductsPrice,
  calculateUpgradeOptionsPrice,
  calculateOfferedPrice,
  isValidPhoneMobileNumber,
  sanitizePhone,
  isProductActive,
  isUserNeedManagerConfirm,
  isOrderReviewedByManager,
  isOrderApprovedByManager,
  isProductValid,
  reduceVAT,
  isValidEmailRegex,
  calculateSubProductPriceWithoutCommission,
  calculateSubProductCommission,
  calculateSubProductPrice,
  getDeliveryPriceForInvoice,
  FoodRequestsIds,
  exportToExcel,
  order: Order_default,
  themeNames,
  AllowedSystemIdBudgetLoadPaymentType,
  report: Report_default,
  utils: utils_default2,
  product: Product_default,
  provider: Provider_default
};
export {
  src_default as default,
  exportToExcel,
  Order_default as order,
  Product_default as product,
  Provider_default as provider,
  Report_default as report,
  utils_default2 as utils
};
